<template>
    <div class="min-h-screen bg-gray-50">
      <div class="mx-auto max-w-7xl px-4 py-8">
        <!-- 产品类型选择模块 -->
        <section class="mb-8">
          <h2 class="mb-6 text-xl font-medium">选择产品</h2>
          <div class="grid grid-cols-8 gap-4">
            <div 
             v-for="(item,index) in cates"
              :key="index"
              class="flex flex-col items-center cursor-pointer p-2 rounded-lg hover:bg-gray-100 transition-colors"
              :class="{ 'bg-blue-50': item.checked }"
                style="position: relative;"
                @click="selectType(item,index)" 
            >
              <!-- -->
    
              <div class="w-20 h-20 mb-2 bg-white shadow-sm ">
                <img  v-if="item.img"
                  :src="item.img" 
                  class="w-full h-full"
                 
                />
              </div>
              <div class="text-center" >
                <p class="text-sm mb-1 font-medium text-gray-700">{{ item.name }}</p>
              </div>

              <i class="fas fa-square-check text-2xl" 
              style="position: absolute;top: 5px;right: 5px;"
              :class="item.checked ? 'text-blue-500' : 'text-gray-200'"
               @click.stop="selectProduct(item,index)"
              ></i>
            
            </div>
          </div>
        </section>
  
        <!-- 盒子类型选择模块 -->
        <section 
          class="mb-8"
     
        >
          <h2 class="mb-6 text-xl font-medium">选择产品子类型</h2>
          <div class="flex gap-4 overflow-x-auto pb-2">
            <button 
             v-for="item,index in list"
                @click="selectCate(item,index)"
              class="px-6 py-2 border rounded-lg whitespace-nowrap transition-all"
              :class="{
                'border-blue-500 text-blue-500 bg-blue-50':item.checked,
                'border-gray-300 text-gray-600 hover:border-blue-300': item.checked
              }"
         
            >
            <!-- selectedBox -->
              {{ item.name }}
            </button>
          </div>
        </section>
  
        <!-- 文件上传模块 -->
        <section class="mb-8">
          <h2 class="mb-2 text-xl font-medium">上传设计文件</h2>
          <!-- <template v-if="!isReadyForUpload">
            <p class="text-gray-500 mb-4">请先选择产品类型和盒子类型</p>
          </template> 
           v-else
          -->
          <template>
            <!-- <p class="text-gray-500 mb-4">
              当前选择: {{ cates[selectedType].name }} - {{ getBoxTypes[selectedBox] }}
            </p> -->
            <div class="draggable-list" v-if="list.length > 0"  v-loading="isloading">
            <draggable class="wrapper" v-model="image">
                <transition-group>
                    <div v-for="(item, index) in image" :key="item">
                        <div class="item">
                            <img v-img-url="item.file_path" alt="file_path" />
                            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                                    class="el-icon-close"></i></a>
                        </div>
                    </div>
                </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload">
                <i class="el-icon-plus"></i>
            </div>
        </div>

          </template>
        </section>
      </div>
      <el-button @click="tonext" type="primary" class="mp20">下一步</el-button>
        <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload"
            @returnImgs="returnProductImgsFunc">上传图片
        </Upload>
    </div>
  </template>
  
  <script>
      import HproductApi from '@/api/hproduct.js';
    import qs from 'qs';
    import Upload from "@/components/file/Upload";
    import draggable from "vuedraggable";
    import $ from 'jquery'
    import '@fortawesome/fontawesome-free/css/all.min.css'
  export default {
    components: {
            Upload,
            draggable
        },
    name: 'ProductUpload',
    data() {
      return {
   
        selectedType:0,
        isloading:false,
                cateIndex1: 0,
                cateIndex2: 0,
                image: [],
                pageSize: 20,
                curPage: 1,
                totalDataNumber: 0,
                list: [],
                isProductUpload: false,
                cates: [],
      }
    },
    computed: {
      getBoxTypes() {
        if (this.selectedType === -1) return []
        return this.boxTypesList[this.selectedType % this.boxTypesList.length]
      },
      isReadyForUpload() {
        return this.selectedType !== -1 && this.selectedBox !== -1
      }
    },
    created() {
            let that = this
            // localStorage.clear();
            that.getList()
        },
    methods: {
        handleSizeChange() {

},
handleCurrentChange() {

},
selectProduct(item, index) {
    let that = this
    if (that.cates[index].checked == false) {
        console.log(that.cates[index].children[0])
        that.cates[index].checked = true
        that.list = that.cates[index].children
        that.image = that.cates[index].children[0].images
        that.list[0].checked = true
        that.cates[index].children[0].checked = true
        that.cateIndex1 = index
        that.cateIndex2 = 0
    } else {
        that.cates[index].checked = false
        that.list = []
        that.cateIndex1 = -1
        that.cateIndex2 = -1
        that.reset(index)
    }

},
selectType(item,index) {
    let that = this

    if(that.cates[index].children.length <= 0 ){
        this.$message.error("未获取到子类型");
        return;
    }

    that.list = that.cates[index].children
    that.image = that.cates[index].children[0].images
    that.cateIndex1 = index
    that.cateIndex2 = 0
},
selectCate(item, index) {
    let that = this
    that.selectedBox = index
    that.cateIndex2 = index
    that.image = that.cates[that.cateIndex1].children[index].images
    that.cates[that.cateIndex1].children.forEach((v, i) => {
        if (i == index) {
            v.checked = true
        } else {
            v.checked = false
        }
    })

    that.list.forEach((v, i) => {
        if (i == index) {
            v.checked = true
        } else {
            v.checked = false
        }
    })
},
reset(index) {
    let that = this
    that.cates[index].children.forEach((v, i) => {
        v.checked = false
        v.images = []
    })
},
tonext() {
    let that = this
    let temp = []
    that.cates.forEach((v, i) => {
        if (v.checked == true) {
            temp.push(v)
        }
    })
    if(temp.length <= 0){
        this.$message.error("请选择产品");
        return;
    }
    console.log(temp)
    let str = JSON.stringify(temp)
    localStorage.setItem('params', str)
    console.log(str)
    this.$router.push('/store/placeorder/edit');
},
deleteImg(e) {
    this.image.splice(e, 1);
},
returnProductImgsFunc(e) {
    let that = this
    if (e != null) {
        let imgExpt = ["cdr", "jpg", "jpeg", "png", "ocr"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
                if (e === ext) {
                    prevent = true
                    return false
                }
            });
 element.checked = false
 element.width = 119.67
 element.height = 124.22
 element.name = '20250218170114a503c9723.png'
//                         that.isloading = true
//                         that.isloading = false
//                         that.isloading = true
            // $.ajax({
            //     url: 'https://chzp24537603.vicp.fun/api/upload/remote',
            //     method: "POST",
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     data: JSON.stringify({ // 转成 JSON 字符串
            //         url: element.file_path
            //     }),
            //     contentType: 'application/json', // 明确告诉服务器发送的是 JSON
            //     processData: false, // 禁止 jQuery 转换数据格式
            //     dataType: "json",
            //     success: function(data) {
            //         console.log("请求成功，返回数据：", data);
            //         element.checked = false
            //         element.width = data.width
            //         element.height = data.height
            //         element.name = data.name
            //         that.isloading = false
            //     },
            //     error: function(xhr, status, error) {
            //         console.error("请求出错：", error);
            //     }
            // });

        });

        if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
        }

        that.image = [...that.image, ...e]
        that.cates[that.cateIndex1].children[that.cateIndex2].images = [...that.cates[that.cateIndex1]
            .children[that.cateIndex2].images, ...e
        ]
        this.isProductUpload = false
    }
},
openProductUpload: function() {
    console.log(12312321312312)
    this.isProductUpload = true;
},
getList() {
    let that = this
    let data = {}
    data.page = 1
    data.list_rows = 100
    HproductApi.list(data, true).then(res => {
        if (res.code == 1) {
            console.log(res)
            that.totalDataNumber = res.data.list.total;
            let cates = []
            res.data.list.data.forEach((v, i) => {
                let obj = {}
                obj.checked = false
                obj.name = v.name
                obj.img = v.image
                obj.attr = v.attr
                obj.price = v.price
                obj.hproduct_id = v.hproduct_id
                obj.children = []
                v.hproducttosubcategories.forEach((val, index) => {
                    let tep = {}
                    tep.name = val.subcategories.name
                    tep.id = val.hproduct_subcategory_id
                    tep.images = []
                    tep.checked = false
                    obj.children.push(tep)
                })
                cates.push(obj)
            })
            that.cates = [...that.cates, ...cates]
        }
    })
},
 
    //   handleUpload() {
    //     this.$refs.fileInput.click()
    //   },
    //   onFileChange(event) {
    //     const file = event.target.files[0]
    //     if (file) {
    //       this.uploadFile(file)
    //     }
    //   },
    //   async uploadFile(file) {
    //     try {
    //       const formData = new FormData()
    //       formData.append('file', file)
    //       formData.append('type', this.productTypes[this.selectedType].name)
    //       formData.append('boxType', this.getBoxTypes[this.selectedBox])
          
    //       // 这里调用上传API
    //       // const response = await axios.post('/api/upload', formData)
    //       console.log('上传文件:', file.name)
    //     } catch (error) {
    //       console.error('上传失败:', error)
    //     }
    //   },
    //   onDragOver() {
    //     this.isDragging = true
    //   },
    //   onDragLeave() {
    //     this.isDragging = false
    //   },
    //   onDrop(e) {
    //     this.isDragging = false
    //     const files = e.dataTransfer.files
    //     if (files.length > 0) {
    //       this.uploadFile(files[0])
    //     }
    //   }
    }
  }
  </script>
  
  <style scoped>
  .grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  
  /* 响应式适配 */
  @media (max-width: 1024px) {
    .grid-cols-8 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  
  @media (max-width: 640px) {
    .grid-cols-8 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  .draggable-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
    }

    .draggable-list .wrapper>span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
  </style>


// WEBPACK FOOTER //
// src/views/store/placeorder/indexxx.vue